import React, { Fragment } from 'react';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';
import { styled } from 'dripsy';

import { FilterItem } from './FilterItem';
import { Separator } from '../../common/Separator';
import {
  Category,
  SubCategory,
} from '@models/Tutorials/CategoryModel';

const ChildrenContainer = styled(View)({
  pl: '$9',
});

export interface IFilterSectionItemProps {
  item: Category;
  onChangeValue(item: Category | SubCategory, value: boolean): void;
  withPreSelection?: boolean;
}

export const FilterSectionItem = observer<IFilterSectionItemProps>(
  ({ item, ...props }) => {
    return (
      <Fragment>
        <FilterItem item={item} {...props} />

        {item.isExpanded &&
          item.children.map(function each(i) {
            return (
              <ChildrenContainer key={i.id}>
                <Separator size="$7" />
                <FilterItem
                  item={i}
                  count={i.videosCount}
                  {...props}
                />

                {
                  // If we have nested children
                  // We need to display all of them
                  Array.isArray(i.children) &&
                    i.isExpanded &&
                    i.children.map(each)
                }
              </ChildrenContainer>
            );
          })}
      </Fragment>
    );
  },
);
